module.exports = __webpack_public_path__ + "static/media/backgroundMobile.afde4489.svg";